import { render } from "./delete-account-request.vue?vue&type=template&id=521f1639"
import script from "./delete-account-request.vue?vue&type=script&lang=js"
export * from "./delete-account-request.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__